import api from './apiClient';

// Service for user contact collection in Lambda/DynamoDB
const userContactService = {
  // List all user contact submissions with pagination and filtering
  async getListData(options = {}) {
    const { limit, exclusiveStartKey, filters } = options;
    const params = new URLSearchParams();
    
    if (limit != null) {
      params.append('limit', limit);
    }
    if (exclusiveStartKey) {
      params.append('exclusiveStartKey', exclusiveStartKey);
    }
    if (filters && filters.length > 0) {
      params.append('filter', JSON.stringify(filters));
    }
    
    const queryString = params.toString();
    const url = queryString ? `/userContact?${queryString}` : '/userContact';
    return await api.get(url);
  },
  // Create a new user contact submission
  async create(data) {
    const body = data && typeof data === 'object' ? data : {};
    return await api.post('/userContact', body);
  },
  // Update a user contact submission
  async update(id, data) {
    const body = data && typeof data === 'object' ? data : {};
    return await api.put(`/userContact/${id}`, body);
  },
};

export default userContactService;
